<template>
    <div class="row">
        <GrantApplicationModal
                v-if="addApplicationModalShow"
                :currentApplications="applications"
                @accessGranted="onAccessGranted"
                @hidden="addApplicationModalShow = false"

        ></GrantApplicationModal>
        <div class="col-12">
            <transition name="fade">
                <div v-if="applications.length > 0" class="card">
                    <VueElementLoading :active="busy"/>
                    <div class="card-header d-flex">
                        <h3 class="mb-0" c>{{ $t('applications.your_applications') }}</h3>

                        <div v-if="$isGranted('$gd.service')" class="d-flex justify-content-center align-items-center">
                    <span class="badge badge-primary ml-3">
                        <fa-icon class="cursor-pointer" @click="addApplicationModalShow = true" icon="plus"></fa-icon>
                    </span>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="row" v-if="applications.length > 10">
                            <div class="col-4">
                                <input type="text" class="form-control form-search" :placeholder="$t('_search')"
                                       v-model="search">
                            </div>
                        </div>
                        <div class="d-flex flex-wrap mt-3">
                            <ApplicationEntry
                                    v-for="application in sortedApplications"
                                    :key="application.id"
                                    @selectApplication="logIn(application)"
                                    :is-disabled="(selectedApplication && selectedApplication !== application) || !application.allowedToAuthenticate"
                                    :is-selected="application === selectedApplication"
                                    :application="application"

                            />
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import {fetchCurrentUserApplications} from "@/services/UserService";
import {logInToApplication} from "@/services/ApplicationService";
import applicationsData, {TYPE_UNDEFINED} from "../service/applicationsData";
import GrantApplicationModal from "@/modules/Applications/components/GrantApplicationModal.vue";
import {normalizeApplication} from "@/modules/Applications/service/AppNormalizer";
import ApplicationEntry from "@/modules/Applications/components/ApplicationEntry.vue";
import VueElementLoading from "vue-element-loading";

export default {
    components: {GrantApplicationModal, ApplicationEntry, VueElementLoading},

    data() {
        return {
            applications: [],
            baseUrl: process.env.BASE_URL,
            applicationsData: applicationsData,
            selectedApplication: null,
            search: null,
            addApplicationModalShow: false,
            busy: false,
        }
    },

    created() {
        this.fetchApplications();
    },

    computed: {
        normalizedApplications() {
            return this.applications.map(application => normalizeApplication(application))
                .filter(app => app.mainType !== TYPE_UNDEFINED);
        },

        sortedApplications() {
            const sortedApps = this.normalizedApplications;
            const sortRef = this.applicationsData.map(item => item.app);

            sortedApps.sort((a, b) => {
                return sortRef.indexOf(a.app) - sortRef.indexOf(b.app)
            });

            if (this.search) {
                const search = this.search.toLowerCase().trim();

                return sortedApps.filter(app => {
                    return app.name.toLowerCase().includes(search);
                });
            }
            return sortedApps;
        },
    },

    methods: {
        fetchApplications() {
            this.busy = true;
            return fetchCurrentUserApplications()
                .then(({data}) => this.applications = data.data)
                .finally(() => this.busy = false);
        },
        logIn(application) {
            if (this.selectedApplication) {
                return;
            }
            this.selectedApplication = application;
            logInToApplication(application);
        },

        onAccessGranted() {
            this.addApplicationModalShow = false;
            this.fetchApplications()
                .then(() => {
                    this.$flash.success('Dostęp do aplikacji został przyznany');
                })
        }
    }
}
</script>